import React, { useState } from "react"
import './content-sales-form.scss'
import Banner from '../../../shared/components/molecules/banner/banner';
import FormSales from '../form-sales/form-sales';
import ContentTyPage from '../content-ty-page/content-ty-page'
import numberCurrency from "../../../shared/utils/numberCurrency";
import SEO from '../../../shared/components/atoms/seo/seo'

const ContentSalesForm = props => {
    const { info, SEOconfig } = props
    const { nombre,
        imgenesInmueble,
        tipoDeBien,
        valorInmueble,
        direccionDelInmueble,
        ciudad,
        modelo,
        color,
        tipoVehiculo,
        marca,
        area, slug,
        modalidadDeCompra
    } = info

    const [activeView, setactiveView] = useState('form')

    SEOconfig.slugForm = SEOconfig.slug + '/formulario';
    SEOconfig.meta = [{
        name: 'robots',
        content: 'noindex, nofollow'
    }]

    return (
        <>
            <SEO
                {...SEOconfig}
            />
            {activeView === 'form' ?
                <div className="o-sales-form">
                    <div className="o-sales-form-banner">
                        <Banner
                            nombre={nombre}
                            imagen={imgenesInmueble && imgenesInmueble[0].file.url}
                            showImagenMobile
                        >
                            {tipoDeBien &&
                                <>
                                    <p className="custom-h h4">{tipoDeBien}</p>
                                    <br></br>
                                </>
                            }
                            {nombre &&
                                <>
                                    <h1 className="o-sales-banner_title custom-h h2">{ `Formulario ${nombre}`}</h1>
                                    <br></br>
                                </>
                            }

                            {valorInmueble &&
                                <>
                                    <div className="o-quote-container">
                                        <p>Cuota:</p>
                                        <p className="custom-h h4">{numberCurrency(valorInmueble)}</p>
                                    </div>
                                    <br></br>
                                </>
                            }

                            {area &&
                                <>
                                    <p><b>Area:  </b>{area}</p>
                                    <br></br>
                                </>
                            }

                            {direccionDelInmueble &&
                                <>
                                    <div className="o-location-container">
                                        {/* <img src={iconLocation} alt="icon locacion" className="o-location-icon" /> */}
                                        <p>{direccionDelInmueble}</p>
                                    </div>
                                    <br></br>
                                </>
                            }

                            {modelo &&
                                <>
                                    <p><b>Modelo:  </b>{modelo}</p>
                                    <br></br>
                                </>
                            }

                            {color &&
                                <>
                                    <p><b>Color:  </b>{color}</p>
                                    <br></br>
                                </>
                            }

                            {tipoVehiculo && tipoVehiculo.nombreTab &&
                                <>
                                    <p><b>Tipo:  </b>{tipoVehiculo.nombreTab}</p>
                                    <br></br>
                                </>
                            }

                            {marca &&
                                <>
                                    <p><b>Marca:  </b>{marca}</p>
                                    <br></br>
                                </>
                            }

                            {ciudad &&
                                <>
                                    <div className="o-city-container">
                                        <p><b>Departamento:</b>{ciudad.split(' - ')[1]}</p>
                                        <br></br>
                                        <p><b>Municipio:</b>{ciudad.split(' - ')[0]}</p>
                                    </div>
                                    <br></br>
                                </>
                            }
                        </Banner>
                    </div>
                    <FormSales setactiveView={setactiveView} slug={slug} nombre={nombre} tipoDeBien={tipoDeBien} modalidadDeCompra={modalidadDeCompra} />

                </div>
                :
                <ContentTyPage />

            }
        </>
    )
}

export default ContentSalesForm
